import Api from '../lib/api';
import { PROD_API_URL, DEV_API_URL } from '../config/constants';

const url = process.env.NODE_ENV === 'development' ? DEV_API_URL : PROD_API_URL;

const config = {};

export default {

  fetchKeywordResults(keyword) {
    return Api(config).post(`${url}data-for-seo/serp`, { keyword })
  },

  keywordSummary(data) {
    return Api(config).post(`${url}keyword`, data)
  },

  keywordStats(data) {
    return Api(config).post(`${url}data-for-seo/stats`, data)
  },

  generatePDF(data) {
    return Api({
      responseType: 'blob'
    }).post(`${url}pdf`, data)
  },

  clientIp() {
    return Api(config).get(`${url}tools/ip`)
  }

}